module.exports = __webpack_public_path__ + "img/consult_info2.63f50a47.png";